export enum OnCallRequesterTypes {
  LIST = '@onCallRequester/LIST',
  LIST_SUCCESS = '@onCallRequester/LIST_SUCCESS',
  LIST_FAILED = '@onCallRequester/LIST_FAILED',
}
